export interface YouTubeCacheTagType {
    type: 'YouTube';
    id: 'LIST' | string;
}

export const YouTubeCacheTag: YouTubeCacheTagType = {
    type: 'YouTube',
    id: 'LIST',
};
